import React from 'react';

import { Col } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';

interface IProps {
  label: string;
  fullWidth?: boolean;
  disableUnderline?: boolean;
  id: string;
  mask:
    'phone' | 'creditCard' | 'monthYear' | 'cpfCnpj' | 'postalCode' | 'number' | 'money' | 'singledigit' | 'percent';
  helperText: string;
  error: boolean;
  value: string;
  onChange: (value: any) => void;
  shrink?: any;
  endAdornment?: string;
}

const Input = ({
  label,
  fullWidth = true,
  disableUnderline = true,
  id,
  mask,
  helperText,
  error,
  value,
  onChange,
  shrink = true,
  endAdornment = 'cm'
}: IProps) => {
  return (
    <Col span={24} className='mt-1'>
      <CustomMaskedInput
        label={label}
        fullWidth={fullWidth}
        disableUnderline={disableUnderline}
        id={id}
        mask={mask}
        helperText={helperText}
        error={error}
        value={value}
        onChange={onChange}
        InputLabelProps={{
          shrink
        }}
        endAdornment={endAdornment}
      />
    </Col>
  );
};

export default Input;
